import { render, staticRenderFns } from "./KbvBudgetIndicatorScenario.vue?vue&type=template&id=56586a87&scoped=true"
import script from "./KbvBudgetIndicatorScenario.vue?vue&type=script&lang=js"
export * from "./KbvBudgetIndicatorScenario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56586a87",
  null
  
)

export default component.exports